import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { StrapiGatsbyImageType } from "./common";

export enum CardWrapperVariant {
  BASE = "base",
  INTEGRATION = "integration",
}

export interface CardsDataModel {
  title: string | null;
  subTitle: string | null;
  learnMoreText: string | null;
  learnMoreLink: string | null;
  imgBackgroundColor: string | null;
  id: string;
  icon: string | null;
  cardImage: StrapiGatsbyImageType | null;
  logoImage: StrapiGatsbyImageType | null;
}

export interface CardWrapperDynamicZoneModel extends BaseDynamicZoneModel {
  bgColor: string | null;
  variant: CardWrapperVariant;
  cards: CardsDataModel[] | null;
}
